import api from '../axiosConfig'
export default{
    mutations: {
        Result: () => {
            return false
        }
    },
    actions:{
        GetResponse({commit}, url){
            return new Promise ((resolve, reject) => {
                let config = {
                    headers: {
                        'x-api-key': localStorage.getItem('userToken')
                    }
                }
                commit('Result')
                api.get(url, config).then(res => {
                    resolve(res)
                }).catch(err => {
                    reject(err)
                })
            })
        },
    }
}